export const API_URL = "https://api.sweepandgo.com/api/";
export default API_URL;

export const PUSHER_KEY = "d67d3e8e8fd362854d22";
export const MIX_STRIPE_KEY = "pk_live_51E0qGmKJu52Qq7xnrxTqELFLHxv5TcszizlC6u2pCsAs2yi3LgJTXslgjI9AkDxVjyWojAgc7S9OqsfXCK2nwxrk0010NIY4d3";

export const VERSION = "1.1.115";
